module.exports = {
  answer: "欢迎使用智能客服，您是否想了解以下常见问题",
  topk_qas: [{
    question: "如何借书？",
  },{
    question: "如何预约图书?",
  },{
    question: "借的书逾期未还，费用怎么算?",
  },{
    question: "图书馆哪里有无线网？",
  },{
    question: "图书馆的规章制度",
  }]
}